
    import {Component, Prop, Vue, Emit, Watch} from 'vue-property-decorator';
    @Component
    export default class SearchPhone extends Vue {
      private phone: string = ''
      @Emit ('getPhone')
      sendPhone(phone:string){}
    }
